export function getAll() {
  return [
    {
      value: 0,
      name: "None",
      text: "無",
    },
    {
      value: 1,
      name: "Showmore",
      text: "Showmore",
    },
    {
      value: 2,
      name: "Meepshop",
      text: "Meepshop",
    },
    {
      value: 3,
      name: "OMO",
      text: "OMO珍珠宸",
    },
  ];
}
